import { Configuration, RedirectRequest, LogLevel, PopupWindowAttributes } from "@azure/msal-browser";

// console.log(process.env);
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID ?? "", // example: "38ede2e8-b178-49f4-b56e-615f8b05fe5f",
    authority: process.env.REACT_APP_AUTH_URL ?? "", // example: "https://novexemicaelvalereb2c.b2clogin.com/novexemicaelvalereb2c.onmicrosoft.com/B2C_1_Login_profil",
    knownAuthorities: process.env.REACT_APP_AUTH_KNOWN_URL ? process.env.REACT_APP_AUTH_KNOWN_URL.split(",") : [""], // example: ["novexemicaelvalereb2c.b2clogin.com"],
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true // Set this to false
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    // storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    tokenRenewalOffsetSeconds: 1740,
    /* loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Verbose, // Set log level to verbose
    }, */
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email"],
  
};